// Notes éditoriales de cette interface. Ajouter un ID stable pour chaque nouvelle livraison.
export default {
    "interface": "stock",
    "label": "Stock",
    "entries": [
        {
            "id": "stock-transferts-laboratoire-20260927",
            "date": "2026-09-27",
            "title": "Stocks & transferts : approvisionner le laboratoire",
            "description": "Le menu Stocks affiche désormais la liste des stocks (Pharmacie, Laboratoire) avec leurs quantités et seuils. Depuis « Voir » un stock, « Transférer vers un autre stock » envoie des quantités au laboratoire : le disponible est affiché pour chaque article, une ligne au-delà du disponible est refusée et signalée, et chaque stock garde l'historique des transferts reçus et envoyés.",
            "location": "Menu Stocks → Stocks & transferts → Voir → Transférer vers un autre stock."
        },
        {
            "id": "nouveautes-20260921",
            "date": "2026-09-21",
            "title": "Les nouveautés à portée de clic",
            "description": "La cloche du header ouvre les améliorations propres à cette interface. Le compteur rouge indique celles que vous n’avez pas encore lues. Vous pouvez marquer une notification comme lue individuellement ou utiliser « Tout marquer comme lu » ; la liste reste disponible à tout moment.",
            "location": "Cloche en haut de l’écran. La lecture est mémorisée sur ce navigateur pour votre compte."
        }
    ]
}
